import LocalizedLink from '../Localization/LocalizedLink'
import { Modal } from '../Modal'
import { NewAtGassan } from '../NewAtGassan'
import { Button, Link } from '../gassan-ui'
import { Text } from '../gassan-ui/Typography/Text'
import { useMembershipModalStatus } from './hooks/use-membership-modal-status'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

export const MembershipModal: FC = () => {
  const { showMembershipVariant, handleRequestClose } = useMembershipModalStatus()
  const { t } = useTranslation('other')

  if (!showMembershipVariant) return null

  return (
    <Modal
      defaultOpen
      title={t('myGassanMembership')}
      onOpenChange={(open) => {
        if (!open) {
          handleRequestClose()
        }
      }}
    >
      <Text variant="regular" className="mb-6">
        {showMembershipVariant === 'brand' && t('become-member-modal-brand', { ns: 'other' })}
        {showMembershipVariant === 'wishlist' && t('become-member-modal-wishlist', { ns: 'other' })}
      </Text>
      <NewAtGassan variant="slim" />
      <div className="flex flex-col items-center justify-center gap-6">
        <LocalizedLink href={t('account.create.url', { ns: 'navigation' })} passHref>
          <Button as="link" variant="dark" className="w-full">
            {t('becomeMember', { ns: 'account' })}
          </Button>
        </LocalizedLink>
        <LocalizedLink href={t('account.login.url', { ns: 'navigation' })} passHref>
          <Link as="link" variant="brown">
            {t('account.login.title', { ns: 'navigation' })}
          </Link>
        </LocalizedLink>
      </div>
    </Modal>
  )
}
